import { Controller } from "@hotwired/stimulus"

// 파일 선택 시 이미지 미리보기
export default class extends Controller {
  static targets = ["input", "preview", "uploadArea", "selectedArea", "fileName"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    // 이미지 파일인지 확인
    if (!file.type.startsWith("image/")) return

    const reader = new FileReader()
    reader.onload = (e) => {
      // 미리보기 이미지 업데이트
      this.previewTarget.innerHTML = `
        <img src="${e.target.result}" class="w-full h-full object-cover" alt="미리보기">
      `
      this.previewTarget.classList.remove("bg-gradient-to-br", "from-gray-100", "to-gray-200")
      this.previewTarget.classList.add("bg-gray-100")

      // 업로드 영역 숨기고 선택 완료 영역 표시
      if (this.hasUploadAreaTarget && this.hasSelectedAreaTarget) {
        this.uploadAreaTarget.classList.add("hidden")
        this.selectedAreaTarget.classList.remove("hidden")

        if (this.hasFileNameTarget) {
          this.fileNameTarget.textContent = file.name
        }
      }
    }
    reader.readAsDataURL(file)
  }

  change() {
    // 다시 선택하기 - 파일 입력 트리거
    this.inputTarget.click()
  }

  remove() {
    // 선택 취소
    this.inputTarget.value = ""

    // 원래 영역으로 복구
    if (this.hasUploadAreaTarget && this.hasSelectedAreaTarget) {
      this.uploadAreaTarget.classList.remove("hidden")
      this.selectedAreaTarget.classList.add("hidden")
    }

    // 미리보기 초기화
    this.previewTarget.innerHTML = `
      <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
      </svg>
    `
    this.previewTarget.classList.add("bg-gradient-to-br", "from-gray-100", "to-gray-200")
    this.previewTarget.classList.remove("bg-gray-100")
  }
}
